<!-- Form row -->
<div class="row">
  <div class="col-12">
      <div class="card">
          <div class="card-body">
              <form (ngSubmit)="f.form.valid && onSubmit(f)" #f="ngForm" novalidate>
                  <div class="row">
                      <div class="col-md-6 mb-3">
                          <label for="inputNombre" class="form-label" i18n>Nombre</label>
                          <input type="text" class="form-control" id="inputNombre" i18n-placeholder="@@nombrePlaceholder" placeholder="Nombre" name="nombre"
                              #nombre="ngModel" [(ngModel)]="model.nombre" required
                              [ngClass]="{ 'is-invalid': (nombre.invalid && f.submitted) || (nombre.invalid && (nombre.dirty || nombre.touched))}">
                          <div
                              *ngIf="(nombre.invalid && f.submitted) || (nombre.invalid && (nombre.dirty || nombre.touched))">
                              <p class="validator-message" i18n>Campo obligatorio</p>
                          </div>
                      </div>
                      <div class="col-md-6 mb-3">
                          <label for="inputApellidos" class="form-label" i18n>Apellidos</label>
                          <input type="text" class="form-control" id="inputApellidos" i18n-placeholder="@@apellidosPlaceholder" placeholder="Apellidos"
                              name="apellidos" #apellidos="ngModel" [(ngModel)]="model.apellidos" required
                              [ngClass]="{ 'is-invalid': (apellidos.invalid && f.submitted) || (apellidos.invalid && (apellidos.dirty || apellidos.touched))}">
                          <div
                              *ngIf="(apellidos.invalid && f.submitted) || (apellidos.invalid && (apellidos.dirty || apellidos.touched))">
                              <p class="validator-message" i18n>Campo obligatorio</p>
                          </div>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-6 mb-3">
                          <label for="inputEmail" class="form-label" i18n>Email</label>
                          <input type="email" class="form-control" id="inputEmail" i18n-placeholder="@@emailPlaceholder" placeholder="Email" name="email"
                              #email="ngModel" [(ngModel)]="model.email" required
                              [ngClass]="{ 'is-invalid': (email.invalid && f.submitted) || (email.invalid && (email.dirty || email.touched))}">
                          <div
                              *ngIf="(email.invalid && f.submitted) || (email.invalid && (email.dirty || email.touched))">
                              <p class="validator-message" i18n>Campo obligatorio</p>
                          </div>
                      </div>
                      <div class="col-md-6 mb-3">
                          <label for="inputTelefono" class="form-label" i18n>Teléfono</label>
                          <input type="text" class="form-control" id="inputTelefono" i18n-placeholder="@@telefonoPlaceholder" placeholder="Teléfono"
                              name="telefono" #telefono="ngModel" [(ngModel)]="model.telefono" required
                              [ngClass]="{ 'is-invalid': (telefono.invalid && f.submitted) || (telefono.invalid && (email.dirty || telefono.touched))}">
                          <div
                              *ngIf="(telefono.invalid && f.submitted) || (telefono.invalid && (telefono.dirty || telefono.touched))">
                              <p class="validator-message" i18n>Campo obligatorio</p>
                          </div>
                      </div>
                  </div>


                  <div class="row">
                      <div class="mb-3 col-md-4">
                          <label for="inputState" class="form-label" i18n>Tipo de usuario</label>
                          <select id="inputState" class="form-select" name="nivel_acceso" #nivel_acceso="ngModel"
                              [(ngModel)]="model.nivel_acceso" required>
                              <option value="REPRESENTANTE" i18n>REPRESENTANTE</option>
                              <!--<option>USUARIO</option>-->
                          </select>
                          <div
                              *ngIf="(nivel_acceso.invalid && f.submitted) || (nivel_acceso.invalid && (nivel_acceso.dirty || nivel_acceso.touched))">
                              <p class="validator-message" i18n>Campo obligatorio</p>
                          </div>
                      </div>
                  </div>

                  <div class="text-md-end">
                      <button type="submit" class="btn btn-primary waves-effect waves-light"><span i18n>Guardar</span></button>
                  </div>

              </form>

          </div> <!-- end card-body -->
      </div> <!-- end card-->
  </div> <!-- end col -->
</div>
<!-- end row -->
